import {CardModalProps, MainStore} from "../types";
import style from "./scss/CardModal.module.scss";
import React from "react";
import {useSelector} from "react-redux";

const CardModal = ({id, data}: CardModalProps) => {
    const {generalTexts} = useSelector((state: MainStore) => state.casinoListSlice);
    const bg = {"--logo-bg-color": data.logoBg} as React.CSSProperties;
    const bonusText = {__html: data.bonusText}
    const shouldHideStrip = !data.validForNewPlayers && !data.wageringRequirements && !data.maxCashOutValue && !data.minDepositValue;
    const copyTarget = {"copy-target": `cp_${data.id}`};
    const copyIndicator = {"copy-indicator": ""}
    // @ts-ignore
    return (
        <>
            <div className={`modal fade ${style.modal}`} id={id} tabIndex={-1} aria-labelledby={`#label_${id}`}
                 aria-hidden="true">
                <div className={`modal-dialog ${style['modal-dialog']}`}>
                    <div className={`modal-content ${style['modal-content']}`}>
                        <div className={`modal-header ${style['modal-header']}`}>
                            <img style={bg} loading="lazy" src={data.casinoLogo} alt=""/>
                            <div className="wrap">
                                <span
                                    className={`exclusive in-card ${style.exclusive}`}>{generalTexts.exclusiveText}</span>
                                <p className={style['bonus-name']}>{data.bonusType}</p>
                                <div className={style['bonus-text-wrapper']}>
                                    <p className={style['bonus-condition']}>{data.bonusCondition}
                                        <strong
                                            className={style['additional-condition-text']}>&nbsp;{data.bonusInfo}</strong>
                                    </p>
                                    <p className={style['additional-info']}>{data.additionalInfo}</p>
                                </div>
                            </div>
                            <button type="button" className={`btn-close ${style['btn-close']}`} data-bs-dismiss="modal"
                                    aria-label="Close"/>
                        </div>
                        <div className={`modal-body ${style['modal-body']}`}>
                            {!shouldHideStrip &&
                            <div className={style['bonus-strip']}>
                                {
                                    data.validForNewPlayers &&
                                    <div className={style['bonus-details-item']}>
                                        <p className={style.text}>{generalTexts.validForText}</p>
                                        <strong>{generalTexts.validFor}</strong>
                                    </div>
                                }
                                {data.wageringRequirements && <div className={style['bonus-details-item']}>
                                    <p className={style.text}>{generalTexts.wageringText}</p>
                                    <strong>{data.wageringRequirements}</strong>
                                </div>}
                                {data.maxCashOutValue && <div className={style['bonus-details-item']}>
                                    <p className={style.text}>{generalTexts.maxCashOutText}</p>
                                    <strong>{data.maxCashOutValue}</strong>
                                </div>}
                                {data.minDepositValue && <div className={style['bonus-details-item']}>
                                    <p className={style.text}>{generalTexts.minDepositText}</p>
                                    <strong>{data.minDepositValue}</strong>
                                </div>}
                            </div>
                            }
                            <div className={style['bonus-text']} dangerouslySetInnerHTML={bonusText}/>
                        </div>
                        <div className={`modal-footer ${style['modal-footer']}`}>
                            {data.code &&
                            <div className={style['code-block']}>
                                <div
                                    className={`copy-to-clipboard code-segment ${style['code-segment']}`}
                                    role="button"
                                    tabIndex={0}
                                    {...copyIndicator}
                                    {...copyTarget}>
                                    <svg className="copy">
                                        <use href="#copy"/>
                                    </svg>
                                    <div className={style.text}>{generalTexts.code}</div>
                                    <div className={style.code} id={`cp_${data.id}`}>
                                        {data.code}
                                    </div>
                                    <div
                                        className={`copied-to-clipboard ${style['copied-to-clipboard']}`}>{generalTexts.copiedToClipBoard}</div>
                                    <svg className="checkmark">
                                        <use href="#checkmark"/>
                                    </svg>
                                </div>
                                <div className={style['copy-instructions']} {...copyTarget}>
                                    {generalTexts.clickToCopyCode}
                                </div>
                            </div>
                            }
                            <a data-aff={data.externalAffiliateLink} href={data.internalAffiliateLink}
                               className={`r-btn go-link ${style['go-link']}`}>{generalTexts.ctaText}</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CardModal;
